import { persistStore, persistReducer } from 'redux-persist';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import storageSession from 'redux-persist/lib/storage/session';
import api from '@/services/api';
import authSlice from './features/auth/auth';
import userSlice from './features/user/user';
import offerSlice from './features/offer/offer';

const persistConfig = {
  key: 'root',
  storage: storageSession,
};

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  offer: offerSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
    },
  }).concat(api.middleware), // Add RTK Query middleware here
});
export const persistor = persistStore(store);
export default store;
